import $ from 'jquery';
import { getImagePath } from "@/config/imgConfig";
import {mapGetters,mapActions} from 'vuex'
export default {
	data (){
		return {
			noHeaderScrollerStyle: {},
			pageHeaderHeight: 88,
			userInfo: {
				// userid:'2707b8ba5a21d48c37b7509d5be9f0b4f8080fcf',
				// userid:'18bcf899bfce5903b9eb863c0655bdbaa296cf15',
				userid:'',
				tel:''
			},
			isIPhoneX:false,
			perW:'',
			disW:'',
			imageobj:{},
			platform:'ios',
			levelid:'',
			language:'',
			isgetglobal:false,
			version:'',
			isIOS:true,
			isAndriodX:false,
			isiPad:false
		}
	},
	computed:{
		...mapGetters(['userinfo'])
	},
	created (){
		this.imageobj = window.imagearr;

		if(window.android){
			this.platform = 'android';
		}
		
		
		(function() {
			if (typeof WeixinJSBridge == "object" && typeof WeixinJSBridge.invoke == "function") {
				handleFontSize();
			} else {
				if (document.addEventListener) {
					document.addEventListener("WeixinJSBridgeReady", handleFontSize, false);
				} else if (document.attachEvent) {
					document.attachEvent("onWeixinJSBridgeReady", handleFontSize);
				}
			}
			function handleFontSize() {
				// 设置网页字体为默认大小
				WeixinJSBridge.invoke('setFontSizeCallback', { 'fontSize' : 0 });
				// 重写设置网页字体大小的事件
				WeixinJSBridge.on('menu:setfont', function() {
					WeixinJSBridge.invoke('setFontSizeCallback', { 'fontSize' : 0 });
				});
			}
		})();
		
		var w = $(window).width();
		var h = $(window).height();

		var h1 = h/750;
		var w1 = h1*1624;


		var perW = ((w1/w)*100).toFixed(2) + '%'; 

		this.perW = perW+' 100%'
		this.disW = '50%'

		this.getglobal();
	},
	mounted() {
		
		Date.prototype.format = function (fmt) {
			var o = {
				"M+": this.getMonth() + 1,                   //月份
				"d+": this.getDate(),                        //日
				"h+": this.getHours(),                       //小时
				"m+": this.getMinutes(),                     //分
				"s+": this.getSeconds(),                     //秒
				"q+": Math.floor((this.getMonth() + 3) / 3), //季度
				"S": this.getMilliseconds()                  //毫秒
			};

			//  获取年份 
			// ①
			if (/(y+)/i.test(fmt)) {
				fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
			}

			for (var k in o) {
				// ②
				if (new RegExp("(" + k + ")", "i").test(fmt)) {
				fmt = fmt.replace(
					RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
				}
			}
			return fmt;
		}
	},
	methods: {
		...mapActions(['setinfo']),
		getpath(name, type) {
			return getImagePath(name, type, false);
		},
		getlocalpath(name){
			const n = navigator.platform;
			const u = navigator.userAgent;
			
			if(n == 'Win32'){return ''}
			const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
			const isiPad = u.indexOf('Macintosh') != -1;
			if(isiOS || isiPad){
				return 'myapp://'+this.imageobj[name]
			}else{
				return window.android.getimage(name);
			}
		},	
		jumpInter(to) {
			if (this.$router) {
				this.$router.push(to)
			}
		},
		// object 转 URL 参数
		createQuery(obj) {
			if(obj === null || obj === undefined || obj === "" || obj.length === 0 ) {
				return ""
			}
			let url = '?';
			for (let key in obj) {
				if (obj[key] !== null) {
					if(typeof obj[key] == 'string'){
						url += (key + '=' + encodeURIComponent(obj[key]) + '&');
					}else{
						url += (key + '=' + encodeURIComponent(JSON.stringify(obj[key])) + '&');
					}
				}
			}
			return url.substring(0, url.lastIndexOf('&'));
		},
		// 'xxx.js?name=aa' 转 {name: 'aa'}
		getQueryData(url) {
			url = url.substring(url.indexOf('.js?') + 3);
			let result = {};
			if (url.indexOf("?") != -1) {
				let str = url.substr(1);
				let strs = str.split("&");
				for (let i = 0; i < strs.length; i++) {
					try{
						result[strs[i].split("=")[0]] = JSON.parse(decodeURIComponent(strs[i].split("=")[1]));
					}catch (error){
						result[strs[i].split("=")[0]] = decodeURIComponent(strs[i].split("=")[1]);
					}
				}
			}
			return result;
		},
		transformisRight(obj){
			var str01 = JSON.stringify(obj);
			this.$bridge.callhandler('addPoint',str01);
		},
		regetImage(){
			this.imageobj = window.imagearr;
		},
		getuserinfo(userinfo){
			var str = JSON.stringify(userinfo);
			var obj = JSON.parse(JSON.stringify(userinfo))
			this.userInfo = obj;
		},
		// 打乱数组的方法
		randArr(arr) {
			let needArr = arr.slice(0,arr.length);
			for (var i = 0; i < needArr.length; i++) {
				var iRand = parseInt(needArr.length * Math.random());
				var temp = needArr[i];
				needArr[i] = needArr[iRand];
				needArr[iRand] = temp;
			}
			return needArr;
		},
		judgeBigScreen() {  //，这里根据返回值 true 或false ,返回true的话 则为全面屏
			const n = navigator.platform;
			const u = navigator.userAgent;
			// 电脑返回是不是x系列，本地开发时候用
			if(n == 'Win32'){
				return ;
			}
			const isiPad = u.indexOf('Macintosh') != -1;
			if(isiPad){
				return;
			}
			
			const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
			if(isiOS){
				var strios = JSON.parse(JSON.stringify(window.isIphoneX));
				return strios==1;
			}else{
				var obj = window.android.getGlobalInfo();
				obj = JSON.parse(obj)
				var stran = parseInt(obj.isAndriodX);
				return stran==1;
			}
		},
		getglobal(){
			const n = navigator.platform;
			const u = navigator.userAgent;
			
			if(n == 'Win32'){return ''}
			const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
			this.isiOS = isiOS;
			const isiPad = u.indexOf('Macintosh') != -1;
			this.isiPad = isiPad;

			if(isiOS || isiPad){
				if(window.isIphoneX){
					var str = JSON.parse(JSON.stringify(window.isIphoneX));
					this.isIPhoneX = str==1;	
				}
				if(window.userInfo){
					this.userInfo = window.userInfo;
				}else{
					this.userInfo.isFirst = true;
				}
				this.language = window.language;
				this.levelid = window.levelid;
				this.version = JSON.parse(JSON.stringify(window.edition.version));
			}else{
				var obj = window.android.getGlobalInfo();
				obj = JSON.parse(obj);
				if(obj.userInfo){
					this.userInfo.isFirst = true;
				}else{
					this.userInfo = {
						userid:obj.userid,
						isFirst:obj.isFirst,
						avatar:obj.avatar,
						tel:obj.tel
					}
				}
				if(obj.isAndriodX){
					this.isAndriodX = obj.isAndriodX;
					this.isIPhoneX = this.isAndriodX==1;
				}
				this.language = obj.language;
				this.levelid = obj.levelid;
				this.version = obj.version;
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/mixins/index.js